export default __webpack_public_path__ + "00bbe96c615ba5c89f0ebe1e875bc16f.png";